import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UserMockInterviewsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function UserMockInterviewsSubTab() {
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchInterviews();
  }, []);

  const fetchInterviews = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/user-mock-interviews`);
      setInterviews(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке пользовательских собеседований: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить это пользовательское собеседование? Все связанные вопросы также будут удалены.')) {
      try {
        await axios.delete(`${API_URL}/api/user-mock-interviews/${id}`);
        fetchInterviews();
      } catch (err) {
        setError('Ошибка при удалении собеседования: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="user-mock-interviews-sub-tab">
      <div className="tab-header">
        <h3>Пользовательские Mock-собеседования</h3>
        <button className="btn btn-secondary" onClick={fetchInterviews}>
          🔄 Обновить
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Telegram ID</th>
              <th>Название</th>
              <th>Share ID</th>
              <th>Доступно</th>
              <th>Кол-во вопросов</th>
              <th>Дата создания</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {interviews.length === 0 ? (
              <tr>
                <td colSpan="8" className="empty-state">
                  Нет пользовательских собеседований.
                </td>
              </tr>
            ) : (
              interviews.map((interview) => (
                <tr key={interview.id}>
                  <td>{interview.id}</td>
                  <td>{interview.telegram_id}</td>
                  <td className="title-cell">{interview.title}</td>
                  <td className="share-id-cell">{interview.share_id}</td>
                  <td>
                    <span className={`status-badge ${interview.is_available ? 'available' : 'unavailable'}`}>
                      {interview.is_available ? '✓ Доступно' : '✗ Недоступно'}
                    </span>
                  </td>
                  <td>{interview.questions?.length || 0}</td>
                  <td>{formatDate(interview.created_at)}</td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(interview.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserMockInterviewsSubTab;
